import httpManager from "@/app/shared/utils/httpManager";

/**
 *
 * @param {Object} nodeId
 * @returns {Promise<Object>} Node details
 */

export async function assignVarInNode({
  chatbotId,
  nodeId,
  varId,
}: {
  chatbotId: number;
  nodeId: number;
  varId: number;
}) {
  const url = `/chatbots/variables`;
  const response = await httpManager.post(url, {
    bot: chatbotId,
    node: nodeId,
    variable: varId,
  });
  return response.data;
}
